// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/train-certificate.css
// module id = 2684
// module chunks = 2